import { api } from '@/services/api/main/axios';
import _ from 'lodash';
import type { UserWorkspace } from '@/services/models';

export type UserWorkspaceWritePayload = Record<string, unknown> & { id: string };

export type UserWorkspaceCreatePayload = Record<string, unknown>;

export const getUserWorkspacesApiRequest = async (): Promise<UserWorkspace[]> => {
  const res = await api.get<{ payload: UserWorkspace[] }>('user/workspaces');
  return _.orderBy(res.data.payload, ['deletable', 'name'], ['asc', 'asc']);
};

export const getUserWorkspaceItemsApiRequest = async ({
  workspaceId,
}: {
  workspaceId: string;
}): Promise<unknown> => {
  const res = await api.get<{ payload: unknown }>(`user/workspaces/${workspaceId}/items`);
  return res.data.payload;
};

export const putUserWorkspaceApiRequest = async (
  payload: UserWorkspaceWritePayload,
): Promise<UserWorkspace> => {
  const res = await api.put<{ payload: UserWorkspace }>(`user/workspaces/${payload.id}`, { ...payload });
  return res.data.payload;
};

export const postUserWorkspaceApiRequest = async (
  payload: UserWorkspaceCreatePayload,
): Promise<UserWorkspace> => {
  const res = await api.post<{ payload: UserWorkspace }>('user/workspaces', { ...payload });
  return res.data.payload;
};

export const deleteWorkspaceApiRequest = async (id: string): Promise<unknown> => {
  const res = await api.delete<{ payload: unknown }>(`/v2/workspaces/${id}`);
  return res.data.payload;
};
